import { getTemas } from "../helpers/temas"

const initialState = {
    temas: []
}
const TEMAS_LOADED = '[TEMAS LD] TEMAS LOADED'
const TEMA_ADD = '[TEMA ADD] TEMA ADD'
const TEMA_DEL = '[TEMAS DL] TEMAS DEL'
const TEMA_UPDATE = '[TEMAS UP] TEMA UPDATE'
const TEMA_CLEANING = '[TEMAS CL] TEMA CLEANING'



export const  startLoadTemas = (email, id) => {
    return async (dispatch) => {
        const temas = await getTemas(email, id);
        dispatch(setTemas(temas))
    }
}

const setTemas = (temas) => ({
    type: TEMAS_LOADED,
    payload: temas
})

export const startNewTema = (id, nameTema, fecha) => {
    return async (dispatch) => {
        const newTema = {
            name: nameTema,
            date: fecha
        }
        dispatch(addNewTema(id, newTema));
    }
}

const addNewTema = (id, data) => ({
    type: TEMA_ADD,
    payload: {
        id, ...data
    }
})


export const refreshTemas = (id,name) => ({
    type: TEMA_UPDATE,
    payload: {
        id,
        name
    }
})

export const deleteThemes = (id) => ({
    type: TEMA_DEL,
    payload: id
})

export const logoutthemes = () => ({type: TEMA_CLEANING})

const TemasReducer = (state = initialState, action ) => {
    switch (action.type) {
        case TEMAS_LOADED:
            return {
                ...state,
                temas: [...action.payload]
        }
        case TEMA_ADD:
            return{
                ...state,
                temas: [...state.temas, action.payload]
            }
        case TEMA_DEL:
            return {
                ...state,
                temas: state.temas.filter(e => e.id !== action.payload)
            }
        case TEMA_UPDATE:
            return {
                ...state,
                temas: state.temas.map(
                    e => (e.id === action.payload.id) ?
                        {...e , name: action.payload.name}
                    :
                        e
                )
            }
        case TEMA_CLEANING:
            return {}
        default:
            return state
    }
}

export default TemasReducer;